import './style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { gsap } from 'gsap';

/**
 * Loaders
 */
const loadingBarElement = document.querySelector( '.loading-bar' );

const loadingManager = new THREE.LoadingManager(
  // Loaded
  () => {
    // Wait a little
    window.setTimeout( () => {

      // Update loadingBarElement
      loadingBarElement.classList.add( 'ended' );
      loadingBarElement.style.transform = '';
    }, 500 );

    window.setTimeout( () => {
      sceneReady = true;
    }, 2000 );
  },

  // Progress
  ( itemUrl, itemsLoaded, itemsTotal ) => {
    // Calculate the progress and update the loadingBarElement
    const progressRatio = itemsLoaded / itemsTotal;
    loadingBarElement.style.transform = `scaleX(${progressRatio})`;
  },
);
const gltfLoader = new GLTFLoader( loadingManager );
const cubeTextureLoader = new THREE.CubeTextureLoader( loadingManager );

/**
 * Base
 */
// Debug
const debugObject = {};

// Canvas
const canvas = document.querySelector( 'canvas.webgl' );

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color( 0x55419 );


// background
const buffgeoBack = new THREE.BufferGeometry();
buffgeoBack.fromGeometry( new THREE.IcosahedronGeometry( 3000, 2 ) );

const back = new THREE.Mesh( buffgeoBack, new THREE.MeshBasicMaterial( {
  map: gradTexture(
    [[0.75, 0.6, 0.4, 0.25], ['#554191', '#4d5a8c', '#2C428D', '#2D459B']] ),
  side: THREE.BackSide,
  depthWrite: false,
  fog: false,
} ) );

//back.geometry.applyMatrix(new THREE.Matrix4().makeRotationZ(15*ToRad));
scene.add( back );

//----------------------------------
//  TEXTURES
//----------------------------------

function gradTexture(color) {

  const c = document.createElement( 'canvas' );
  const ct = c.getContext( '2d' );
  const size = 1024;

  c.width = 16;
  c.height = size;
  const gradient = ct.createLinearGradient( 0, 0, 0, size );

  let i = color[ 0 ].length;
  while ( i-- ) { gradient.addColorStop( color[ 0 ][ i ], color[ 1 ][ i ] ); }

  ct.fillStyle = gradient;
  ct.fillRect( 0, 0, 16, size );
  const texture = new THREE.Texture( c );
  texture.needsUpdate = true;
  return texture;
}

function basicTexture(n){
  const canvas = document.createElement( 'canvas' );
  canvas.width = canvas.height = 64;
  const ctx = canvas.getContext( '2d' );
  let color;
  if(n===0) color = "#3884AA";// sphere58AA80
  if(n===1) color = "#61686B";// sphere sleep
  if(n===2) color = "#AA6538";// box
  if(n===3) color = "#61686B";// box sleep
  if(n===4) color = "#AAAA38";// cyl
  if(n===5) color = "#61686B";// cyl sleep
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, 64, 64);
  ctx.fillStyle = "rgba(0,0,0,0.2)";
  ctx.fillRect(0, 0, 32, 32);
  ctx.fillRect(32, 32, 32, 32);

  const tx = new THREE.Texture( canvas );
  tx.needsUpdate = true;
  return tx;
}


/**
 * Models
 */
gltfLoader.load(
  '/models/cerveau.gltf',
  ( gltf ) => {
    gltf.scene.scale.set( 0.4, 0.4, 0.4 );
    gltf.scene.rotation.y = Math.PI * 0.5;
    gltf.scene.position.set( 0, -8, 0);

    document.getElementById("three").addEventListener("click", function(){
      gltf.scene.children[0].children[1].visible = !gltf.scene.children[0].children[1].visible;
    });

    scene.add( gltf.scene );
  },
);


/**
 * Points of interest
 */

const raycaster = new THREE.Raycaster();

const points = [
  {
    position: new THREE.Vector3( 6.6, 4.3, -4.6 ),
    element:  document.querySelector('.point-0')
  } ,

  {
    position: new THREE.Vector3(-2.5, 3.6, - 7.4),
    element: document.querySelector('.point-1')
  },

  {
    position: new THREE.Vector3(-3.5, -2.3, - 6.6),
    element: document.querySelector('.point-2')
  },

  {
    position: new THREE.Vector3(-7.4, -2, - 4.4),
    element: document.querySelector('.point-3')
  },

  {
    position: new THREE.Vector3(-0.14, -2.79, - 1.9),
    element: document.querySelector('.point-4')
  } ,

  {
    position: new THREE.Vector3(-1.9, -4.4, - 1.5),
    element: document.querySelector('.point-5')
  }  ,

  {
    position: new THREE.Vector3(-5.3, -4.3, - 3),
    element: document.querySelector('.point-6')
  }

]

//console.log( points );


/**
 * Floor
 */
const floor = new THREE.Mesh(
  new THREE.PlaneBufferGeometry( 10, 10 ),
  new THREE.MeshStandardMaterial( {
    color: '#695B8B',
    metalness: 0,
    roughness: 0.5,
  } ),
);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI * 0.5;
floor.position.set( -2, -8, 0);
scene.add( floor );


/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight( 0xffffff, 0.6 );
scene.add( ambientLight );

const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.54 );
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set( 1024, 1024 );
directionalLight.shadow.camera.far = 25;
directionalLight.shadow.camera.left = -10;
directionalLight.shadow.camera.top = 10;
directionalLight.shadow.camera.right = 10;
directionalLight.shadow.camera.bottom = -10;
directionalLight.position.set( 45, 85, -20 );
scene.add( directionalLight );

const directionalLight2 = new THREE.DirectionalLight( 0xffffff, 0.7 );
directionalLight2.castShadow = true;
directionalLight2.shadow.mapSize.set( 1024, 1024 );
directionalLight2.shadow.camera.far = 25;
directionalLight2.shadow.camera.left = -10;
directionalLight2.shadow.camera.top = 10;
directionalLight2.shadow.camera.right = 10;
directionalLight2.shadow.camera.bottom = -10;
directionalLight2.position.set( -20, -110, 12 );
scene.add( directionalLight2 );


/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener( 'resize', () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize( sizes.width, sizes.height );
  renderer.setPixelRatio( Math.min( window.devicePixelRatio, 2 ) );
} );

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera( 75, sizes.width / sizes.height, 0.1,
  20000 );
camera.position.set( -2.1, -5, -16 );
scene.add( camera );

// Controls
const controls = new OrbitControls( camera, canvas );
controls.enableDamping = true;


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer( {
  canvas: canvas,
  antialias: true,
  physicallyCorrectLights: true
} );

renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize( sizes.width, sizes.height );
renderer.setPixelRatio( Math.min( window.devicePixelRatio, 2 ) );


let sceneReady = false;
/**
 * Animate
 */
const tick = () => {
  // Update controls
  controls.update();

  // Update points only when the scene is ready
  if( sceneReady ) {

    // Go through each point
    for ( const point of points ) {
      // Get 2D screen position
      const screenPosition = point.position.clone();
      screenPosition.project( camera );

      // Set the raycaster
      raycaster.setFromCamera( screenPosition, camera );
      const intersects = raycaster.intersectObjects( scene.children, true );

      // No intersect found
      if( intersects.length === 0 ) {
        // Show
        point.element.classList.add( 'visible' );
      }

      // Intersect found
      else {
        // Get the distance of the intersection and the distance of the point
        const intersectionDistance = intersects[ 0 ].distance;
        const pointDistance = point.position.distanceTo( camera.position );

        // Intersection is close than the point
        if( intersectionDistance < pointDistance ) {
          // Hide
          point.element.classList.remove( 'visible' );
        }
        // Intersection is further than the point
        else {
          // Show
          point.element.classList.add( 'visible' );
        }
      }

      const translateX = screenPosition.x * sizes.width * 0.5;
      const translateY = - screenPosition.y * sizes.height * 0.5;
      point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`;
    }
  }

  // Render
  renderer.render( scene, camera );

  // Call tick again on the next frame
  window.requestAnimationFrame( tick );
};


tick();
